import React from 'react';
import { capitalize } from 'lodash';
import { getOnlyOWNRRMDs } from '../../../redux/modules/RMD/RMDSetting.selectors';
import { useDispatch, useSelector } from 'react-redux';
import { openModal } from 'src/redux/modules/modals/actions';
import './AutomaticDelete.scss';
import {
  isSalesforceRep,
  isCustomerWebViewEnabled,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import {
  AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL,
  AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS,
  DELETE_AUTO_RMD,
} from '../../../redux/modules/modals/modals.module';
import { moduleActions } from '../../../redux/modules';

const DeleteAutoRMDModal = ({ closeModal }) => {
  const dispatch = useDispatch();
  const fund = { productType: 'MUTUAL_FUND' };
  const existingRMD = useSelector(getOnlyOWNRRMDs);
  const payload = {
    rmdAgreements: existingRMD.map((fund) => {
      return {
        agreementId: parseInt(fund.sourceAgreementKey.agreementID),
        rmdPercentage: fund.amount,
        delivery:
          fund.type.enumerationID === 20
            ? 'InKindTransfer'
            : existingRMD[0]?.deliveryType?.enumerationName,
        federal_tax_withholding_percentage: 35,
        targetAgreementId: parseInt(fund.targetAgreementKey.agreementID),
      };
    }),
    activeIndicator: true,
    withdrawMonthText: existingRMD?.[0]?.transfers
      .filter((monthObj) => monthObj.status.enumerationID === 10)
      .map((month) => `${month.month}`),
    withdrawDayNumber: existingRMD?.[0]?.transferDays[0],
    rmdTypeCode: capitalize(existingRMD?.[0]?.rmdType),
    rmdPlanTypeId: existingRMD?.[0]?.rmdPlanTypeId,
    rmdScheduleStatus: 'DELETE',
    test: 'test',
  };

  return (
    <div className="automatic-delete-container">
      <div className="automatic-delete-title">
        Are you sure you want to delete your Auto-RMD?
      </div>
      <div className="automatic-delete-sub-title">
        This will remove scheduled distributions calculated to fulfill your
        yearly T. Rowe Price RMD.
      </div>
      <div className="automatic-delete-buttons-container">
        <a
          id="delete-modal-cancel"
          onClick={() => closeModal(DELETE_AUTO_RMD)}
          className="automatic-delete-cancel-btn"
        >
          No, Cancel
        </a>

        <button
          id="delete-modal-confirm-btn"
          className={'automatic-delete-delete-btn-rmd'}
          disabled={!!isCustomerWebViewEnabled && !isSalesforceRep}
          onClick={() => {
            Promise.all([
              dispatch(moduleActions.deleteExistingRMD(payload)),
              closeModal(DELETE_AUTO_RMD),
            ]).then(
              () => {
                Promise.all([dispatch(moduleActions.getRMDLimits())]).then(
                  () => {
                    dispatch(
                      openModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS, {
                        fund: fund,
                        type: 'Auto-RMD',
                        actionType: 'delete',
                      })
                    );
                  },
                  () => {
                    dispatch(
                      openModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL, {
                        fund: fund,
                        type: 'Auto-RMD',
                        actionType: 'delete',
                      })
                    );
                  }
                );
              },
              () => {
                dispatch(
                  openModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL, {
                    fund: fund,
                    type: 'Auto-RMD',
                    actionType: 'delete',
                  })
                );
              }
            );
          }}
        >
          Yes, Delete
        </button>
      </div>
    </div>
  );
};

export default DeleteAutoRMDModal;
